import React, { useEffect, useState, createContext, useContext, PropsWithChildren } from 'react';
import API, { TokenData, UserLogin } from '../API';
import moment from 'moment';

type HasAccessFn = (a: number | number[], use_or?: boolean, ignore_super?: boolean)=>boolean;

const UserAuthContext = createContext<{
	login: boolean,
	user: UserLogin["user"],
	access: UserLogin["access"],
	dev: boolean,
	updateNotifications: (n: number)=>void,
	refreshNotifications: ()=>void,
	hasAccess: HasAccessFn,
	logout: ()=>void,
	refresh: ()=>void,
}>({
	login: false,
	user: null,
	access: null,
	dev: false,
	hasAccess: ()=>false,
	logout: ()=>null,
	refresh: ()=>null,
	updateNotifications: ()=>null,
	refreshNotifications: ()=>null,
});
var useUser = () => useContext(UserAuthContext);

var UserProvider = (props: PropsWithChildren)=>{
	var [user, setUser] = useState<UserLogin>(JSON.parse(localStorage.getItem('user_data') || null));
	var [token, setToken] = useState<TokenData>(JSON.parse(localStorage.getItem('access_token') || null))
	var now = moment().unix();
	var is_expired = !token || (token.expires<=(now+30));

	var updateData = ()=>{
		try{
			var d = JSON.parse(localStorage.getItem('user_data'));
			setUser(d);
			return d as UserLogin;
		}catch(e){}
	}

	var updateToken = ()=>{
		try{
			var d = JSON.parse(localStorage.getItem('access_token'));
			setToken(d);
			return d as TokenData;
		}catch(e){}
	}

	var refresh = ()=>{
		API.getLogin(true);
	}

	var updateNotifications = (amount: number)=>{
		if(!user) return;
		var usr = {...user.user};
		usr.notifications = amount;
		setUser({
			...user,
			user: usr,
		})
	}

	var refreshNotifications = ()=>{

	}

	var hasAccess = (a: number | number[], use_or: boolean=true, ignore_super: boolean=false)=>{
		if(!user || !user.access || is_expired) return false;
		if((user.user.superadmin && ignore_super===false) || typeof a==='undefined' || (a as number[]).length==0) return true;
		if(Array.isArray(a)){
			var acc = (a as any) as number[], valid = [];
			for(var i of acc){
				var ha = user.access.indexOf(i);
				if(ha!=-1){
					if(use_or) return true;
					valid.push(i);
				}
			}
			return valid.length>=a.length;
		}else{
			return user.access && user.access.indexOf(a)!=-1;
		}
	}

	var logout = ()=>{
		API.logout();
	}

	useEffect(()=>{
		refresh();
		window.addEventListener('user_data', updateData);
		window.addEventListener('user_token', updateToken);
		return ()=>{
			window.removeEventListener('user_data', updateData);
			window.removeEventListener('user_token', updateToken);
		}
	}, [])
	
	return <UserAuthContext.Provider value={{
		login: !is_expired && !!user,
		user: is_expired ? null : user?.user,
		access: is_expired ? null : user?.access,
		dev: hasAccess(60000, false, true),
		updateNotifications,
		refreshNotifications,
		hasAccess,
		logout,
		refresh,
	}}>
		{props.children}
	</UserAuthContext.Provider>
}

export {
	useUser,
	UserProvider,
}